<template>
	<aside class="property" :class="{ 'shrink': !isVisible, 'bg-color-editing': isUserEditing !== user.id && isUserEditing }">
		<div class="d-flex align-items-start justify-content-between">
			<div v-if="isLoading" class="absolute loader-circle">
				<div class="is-loading"></div>
			</div>
			<div class="property-title">
				{{ $t('Composition Properties') }} -{{ label ? label.toUpperCase() : 'DEFAULT COMPOSITION' }}
			</div>
			<button class="btn btn-default btn-sm btn-icon property-toggle"
				@click="isVisible = !isVisible">
				<i class="material-icons" v-if="isVisible">chevron_left</i>
				<i class="material-icons" v-else>chevron_right</i>
			</button>
		</div>
		<!-- <transition name="fade" > -->
			<div class="property-content pr-2"  :class="{'pointer-events-none': isLocked  ? isLocked.is_locked : true}">
				<!-- Template & Data -->
				<div class="mb-4">
					<label class="text-primary">
						{{ $t('General') }}
					</label>
					<div class="form-group mb-3">
						<!-- <select :class="{ 'error-input': !compositionId && isRequired }" class="form-control" placehov
							@input="onSelect"
							v-model="compositionId">
							<option value="" disabled selected hidden>Select Composition</option>
							<option v-for="compositionOption in compositions"
								:key="compositionOption.id" :value="compositionOption.id">
								{{ compositionOption.name }}
							</option>
							<option value="0" disabled
								v-if="!isFetchingCompositions && compositions.length === 0">
								{{ $t('No Compositions Available') }}
							</option>
						</select> -->
						<md-menu md-align-trigger md-direction="bottom-start" class="col-lg-12 pr-0 pl-0">
							<div md-menu-trigger>
								<custom-input
									:class="{ 'error-input': !compositionId && isRequired }"
									type="select"
									:align="'left'"
									:label="$t('Composition')"
									:value="labelComposition"
								/>
							</div>
							<md-menu-content id="scrolls-style">
								<md-menu-item class="item-property-rundown-composition" v-for="item in compositions" @click="compositionId = item.id"
									:key="item.key">{{item.name}}
								</md-menu-item>
								<md-menu-item v-if="compositions.length <= 0" class="assets-item-wrapper-list item-property-rundown-composition">
									Not available
								</md-menu-item>
							</md-menu-content>
						</md-menu>
					</div>
					<div class="form-group mb-3">
						<custom-input class="mb-3"
							align="left"
							:label="$t('Label')"
							:max="40"
							:required="isRequired"
							@blur="save"
							@keyenter="save"
							v-model="label"
							:restrictChar="true"
							/>
					</div>
					<div class="mb-3 d-flex">
						<div>
							<custom-input
								class="mr-1"
								type="number"
								:label="$t('Opacity')"
								:required="isRequired"
								:min="0"
								:max="100"
								:step="1"
								:suffix="'%'"
								v-model="opacity"
								@blur="save"
								@keyenter="onInputEnter('opacity', ...arguments)"
							/>
						</div>
						<div class="col-md-6 ml-a mb-4 pl-1 mr-0 pr-0">
							<custom-input
								type="number"
								field="index"
								:label="$t('Layer')"
								:required="isRequired"
								:max="100"
								:index-duplicated="isIndexDuplicated"
								@blur="save"
								@keyenter="onInputEnter('layer', ...arguments)"
								v-model="layerIndex"
							/>
						</div>
					</div>
					<div>
						<md-switch
							class="md-primary mt-0 mb-3 mr-0 pr-0"
							@change="save"
							v-model="showEditor">
							{{ $t('Show Editor') }}
						</md-switch>
					</div>
					<div class="pt-2">
						<position-settings
						:width.sync="width"
						:height.sync="height"
						:position.sync="position"
						:isRatio.sync="isRatio"
						:isPosition.sync="isPosition"
						@save="save"
						:x.sync="x"
						:y.sync="y"
						@change="onKeywordChange"
						@keyenter="save"
						@reset="resetSizePosition"
						@rescale="rescaleSize"
						:type="'composition'"
						/>
					</div>
					<!-- on complete label -->
					<!-- <div class="mt-2">
							<div class="d-flex justify-content-between">
								<div>
									<label class="text-primary">{{ $t('On Complete') }}</label>
								</div>
							</div>
					</div> -->
					<!-- on complete controller -->
					<!-- <div class="">
						<md-menu
							:md-active.sync="isOnComplete"
							class="h-fc col-md-12 pr-0 pl-0"
							md-size="small"
							md-direction="top-start"
							md-align-trigger>
							<div v-if="selectedOnComplete"
								class="form-control cur-p relative mb-4"
								md-menu-trigger>
								<item-option
									:item="selectedOnComplete"
									v-if="selectedOnComplete"
								/>
								<div class="text-right">
									<div @click.stop="removeOnComplete" class="modal-close-assets absolute delete-complete-add">
										<i class="material-icons">cancel</i>
									</div>
								</div>
							</div>
							<div v-else md-menu-trigger>
								<input
									type="text"
									class="form-control mb-4"
									:placeholder="$t('Stop (default)')"
									@input="onKeywordChange"
									v-model="keywordSearchOnComplete"
									@click.stop="toggleOnComplete"
								/>
								<item-option
									:item="selectedOnComplete"
									v-if="selectedOnComplete"
								/>
							</div>
							<md-menu-content id="scrolls-style"
							:class="{'macro-content-wrapper-list': filteredParent.length > 6, 'assets-wrapper-list-empty': filteredParent.length === 0,
								'assets-wrapper-list-1': filteredParent.length === 1, 'assets-wrapper-list-2': filteredParent.length === 2,
								'assets-wrapper-list-3': filteredParent.length === 3, 'assets-wrapper-list-4': filteredParent.length === 4,
								'assets-wrapper-list-5': filteredParent.length === 5, 'assets-wrapper-list-6': filteredParent.length === 6,
								}"
								>
								<md-menu-item class="item-macros-rundown macro-content-wrapper-list"
									v-for="rundownItem in filteredParent"
									:key="rundownItem.id"
									@click="selectOnComplete(rundownItem)">
									<item-option :item="rundownItem" />
								</md-menu-item>
								<md-menu-item v-if="filteredParent.length <= 0" class="item-macros-rundown macro-content-wrapper-list">
									Oops, there is no assets available
								</md-menu-item>
							</md-menu-content>
						</md-menu>
					</div> -->
					<!-- parent controller -->
					<div class="mt-2">
					<div class="d-flex justify-content-between">
						<div>
							<label class="text-primary">{{ $t('Parent Controller') }}</label>
						</div>
						<div class="ml-0 pl-0">
							<md-switch
								class="md-primary mt-0 mb-2 mr-0"
								@change="save()"
								v-model="isParent">
							</md-switch>
						</div>
					</div>
					</div>
					<div class="d-flex select ">
						<!-- <div class="select w-75 relative">
							<div class="mb-2 mh-40px mr-4">
								<multiselect class="select-input" v-model="parentItem" select-label="" deselect-label="Remove" track-by="id" label="name"
								openDirection="bottom" :optionsLimit="10" placeholder="Search or Select Parent Item" :options="filteredParent" @input="save()"
								:searchable="true" :allow-empty="true" :show-labels="true" :selectedLabel="''">
								<span class="arrow-multiselect" slot="caret">
									<i class="material-icons pb-1 mt-1 ml-2 size-arrow">expand_more</i>
								</span>
								<template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
								</multiselect>
							</div>
						</div> -->
						<!-- new dropdown select assets -->
						<md-menu
							:md-active.sync="isToggleParent"
							class="h-fc mr-3"
							md-size="small"
							md-direction="bottom-start"
							md-align-trigger>
							<div v-if="selectedParent"
								class="form-control cur-p relative w-230px"
								md-menu-trigger>
								<item-option
									:item="selectedParent"
									v-if="selectedParent"
								/>
								<div @click.stop="removeParent" class="modal-close-assets absolute delete-assets-add">
									<i class="material-icons">cancel</i>
								</div>
							</div>
							<div v-else md-menu-trigger>
								<input
									type="text"
									class="form-control w-230px"
									:placeholder="$t('Search or Select Parent Item')"
									v-model="keywordSearchParent"
									@click.stop="toggleParent"
								/>
								<item-option
									:item="selectedParent"
									v-if="selectedParent"
								/>
							</div>
							<md-menu-content id="scrolls-style" class="macro-content-wrapper-list">
								<md-menu-item class="item-macros-rundown macro-content-wrapper-list"
									v-for="rundownItem in filteredParent"
									:key="rundownItem.id"
									@click="selectParent(rundownItem)">
									<item-option :item="rundownItem" />
								</md-menu-item>
								<md-menu-item v-if="filteredParent.length <= 0" class="item-macros-rundown macro-content-wrapper-list">
									Oops, there is no assets available
								</md-menu-item>
							</md-menu-content>
						</md-menu>
						<!-- delay -->
						<div class="select">
							<custom-input
								class="form-input mb-3"
								type="number"
								:label="$t('Delay')"
								:min="-15000"
								:max="15000"
								:step="100"
								:suffix="'ms'"
								v-model="childOrder"
								@keyenter="onInputEnter('delay', ...arguments)"
								@blur="save"
								:allowNegative="true"
							/>
							<!-- <div class="mb-2 mh-60px">
								<multiselect class="select-input" v-model="childOrder" select-label=""
									track-by="id" label="name" openDirection="bottom" placeholder="No Delay" :options="delayList" @input="save()"
									:searchable="true" :allow-empty="true" :show-labels="false">
									<span class="arrow-multiselect" slot="caret">
										<i class="material-icons pb-1 mt-1 ml-2 size-arrow">expand_more</i>
									</span>
									<template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
								</multiselect>
							</div> -->
						</div>
					</div>
				</div>
				<!-- Size & Position -->
			</div>
		<!-- </transition> -->
	</aside>
</template>

<script>
// import Multiselect from 'vue-multiselect';
import { mapGetters } from 'vuex';
// import Multiselect from 'vue-multiselect';
import ItemOption from '@/components/ItemOption.vue';
import {
	delay,
} from '@/lib/helper';
import rundownItemsApi from '@/api/rundownItems';
import compositionsApi from '@/api/compositions';
import CustomInput from '@/components/CustomInput.vue';
import PositionSettings from '@/components/PositionSettings.vue';
import {
	delayList,
} from '@/lib/statics';

// import 'vue-multiselect/dist/vue-multiselect.min.css';
export default {
	name: 'CompositionProperty',
	props: {
		data: {
			type: Object,
		},
		rundown: {
			type: Object,
		},
		filteredItems: {
			type: Array,
		},
		items: {
			type: Array,
			default: () => [],
		},
	},
	components: {
		// Multiselect,
		CustomInput,
		PositionSettings,
		ItemOption,
	},
	sockets: {
		composition_insert(composition) {
			if (composition) {
				this.compositions.push(composition);
			}
		},
		composition_delete(composition) {
			const index = this.compositions.findIndex(({ id }) => id === composition.id);
			if (index !== -1) {
				this.compositions.splice(index, 1);
			}
		},
		composition_update(composition) {
			if (composition) {
				const index = this.compositions.findIndex(({ id }) => id === composition.id);
				if (index === -1) {
					this.compositions.push(composition);
				} else {
					this.$set(this.compositions, index, composition);
				}
			}
		},
	},
	data() {
		return {
			compositions: [],
			compositionId: '',
			composition: null,
			isLoading: false,
			label: '',
			duration: '',
			layerIndex: '',
			showEditor: false,
			width: '',
			height: '',
			position: '',
			x: '',
			y: '',
			isVisible: true,
			isSaving: false,
			isFetchingCompositions: false,
			isRequired: false,
			isRatio: true,
			isPosition: false,
			isActiveEdit: false,
			parentItem: null,
			isParent: false,
			delayList,
			childOrder: 0,
			selectedParent: null,
			selectedOnComplete: null,
			keywordSearchParent: '',
			keywordSearchOnComplete: '',
			isToggleParent: false,
			isOnComplete: false,
			opacity: 100,
		};
	},
	methods: {
		toggleParent() {
			this.isToggleParent = true;
		},
		toggleOnComplete() {
			this.isOnComplete = true;
		},
		updateActiveEdit() {
			this.isSaving = true;
			const callback = (response) => {
				const item = response.data;
				this.$emit('add', item);
				this.isSaving = false;
			};
			const errorCallback = () => {
				this.isSaving = false;
			};
			const params = {
				active_edit: null,
			};
			rundownItemsApi.update(this.data.id, params, callback, errorCallback);
		},
		initData() {
			this.isVisible = true;
			this.reset();
			if (this.data) {
				this.layerIndex = this.data.layer_index;
				this.label = this.data.name;
				let content = this.data.content;
				if (typeof content === 'string') {
					content = JSON.parse(content);
				}
				const activeEdit = this.data.active_edit;
				if (activeEdit && activeEdit !== this.userId) {
					this.isActiveEdit = true;
				}
				if (content) {
					this.duration = content.duration;
					this.showEditor = content.showEditor;
					this.width = content.width;
					this.height = content.height;
					this.position = content.position;
					this.x = content.x;
					this.y = content.y;
					this.isRatio = content.isRatio;
					this.isPosition = content.isPosition;
					this.isParent = content.isParent || false;
					// this.parentItem = this.filteredParent.find(item => item.id === content.parentItem) || '';
					this.selectedParent = this.filteredParent.find(item => item.id === content.parentItem) || '';
					this.selectedOnComplete = this.filteredParent.find(item => item.id === content.onCompleteItem) || '';

					this.childOrder = content.childOrder || 0;
					this.opacity = content.opacity * 100;
					if (content.composition) {
						const compositionId = content.composition.id;
						if (compositionId !== this.compositionId) {
							this.composition = content.composition;
							this.compositionId = compositionId;
							this.onSelect();
						}
					}
				}
			}
		},
		reset() {
			this.composition = null;
			this.label = '';
			this.layerIndex = 0;
			this.showEditor = false;
			this.width = 1920;
			this.height = 1080;
			this.position = 'default';
			this.x = 0;
			this.y = 0;
			this.opacity = 100;
		},
		save() {
			this.isSaving = true;
			const callback = (response) => {
				const item = response.data;
				this.$emit('add', item);
				this.isSaving = false;
			};
			const errorCallback = () => {
				this.isSaving = false;
			};
			if (this.data) {
				rundownItemsApi.update(this.data.id, this.params, callback, errorCallback);
			} else {
				rundownItemsApi.create(this.params, callback, errorCallback);
			}
		},
		fetchCompositions() {
			this.isFetchingCompositions = true;
			let userId = '';
			if (this.user) {
				userId = this.user.id;
			}
			const params = {
				page: 1,
				limit: 1000,
				user_id: userId,
			};
			const callback = (response) => {
				const compositions = response.data;
				this.compositions = compositions;
				this.isFetchingCompositions = false;
			};
			const errorCallback = () => {
				this.isFetchingCompositions = false;
			};
			compositionsApi.getList(params, callback, errorCallback);
		},
		onKeywordChange() {
			delay(() => {
				// this.fetch(true);
				this.save();
			}, 1200);
		},
		onSelect() {
			const composition = this.compositions.find(({ id }) => id === this.compositionId);
			if (composition) {
				this.composition = composition;
				this.onKeywordChange();
			}
		},
		checkDuplicateIndex() {
			const valueArr = this.filteredItems.map(a => a.layer_index);
			let count = 0;
			for (let i = 0; i < valueArr.length; ++i) {
				if (valueArr[i] === this.layerIndex) count++;
			}
			if (count > 1) {
				return true;
			}
			return false;
		},
		duplicateLayerText() {
			const text1 = 'Other item also using this layer, only one item at a time will be displayed';
			return text1;
		},
		resetSizePosition() {
			this.x = 0;
			this.y = 0;
			this.position = 'default';
			this.width = 1920;
			this.height = 1080;
			this.save();
		},
		selectParent(item) {
			this.selectedParent = item;
			this.keywordSearchParent = '';
			this.save();
		},
		removeParent() {
			this.selectedParent = null;
			this.keywordSearchParent = '';
			this.save();
		},
		selectOnComplete(item) {
			this.selectedOnComplete = item;
			this.keywordSearchOnComplete = '';
			this.save();
		},
		removeOnComplete() {
			this.selectedOnComplete = null;
			this.keywordSearchOnComplete = '';
			this.save();
		},
		onInputEnter(props, value) {
			if (props === 'layer') this.layerIndex = value;
			if (props === 'delay') this.childOrder = value;
			if (props === 'opacity') this.opacity = value;
			this.save();
		},
		rescaleSize() {
			if (this.data.content && this.rundown) {
				const displayWidth = this.rundown.display && this.rundown.display.displaySize.width ? this.rundown.display.displaySize.width : 1920;
				const displayHeight = this.rundown.display && this.rundown.display.displaySize.height ? this.rundown.display.displaySize.height : 1080;
				const spaceCanvasWidth = displayWidth - this.width;
				const spaceCanvasHeight = displayHeight - this.height;
				this.position = 'custom';
				// calculate width and height to keeping the aspect ratio based on the output size on rundown
				const ratioOriginal = Math.min(displayWidth / 1920, displayHeight / 1080);
				// check condition if image not fill canvas & not fit to canvas
				if (((spaceCanvasWidth === 0 && spaceCanvasHeight === 0) || (this.mediaX === 0 && this.mediaY === 0)) || ((this.height !== 1920 * ratioOriginal) && (this.height !== 1080 * ratioOriginal))) {
					this.width = 1920 * ratioOriginal;
					this.height = 1080 * ratioOriginal;
					// change position
					this.x = (displayWidth - this.width) / 2;
					this.y = (displayHeight - this.height) / 2;
				// scaling to fill no matter what the size of media
				} else {
					const ratioFill = Math.max(displayWidth / 1920, displayHeight / 1080);
					this.width = 1920 * ratioFill;
					this.height = 1080 * ratioFill;
					// change position
					this.x = 0;
					this.y = 0;
				}
				this.save();
			}
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
		}),
		filteredParent() {
			const filteredParent = this.items.filter(item => item.id !== this.data.id);
			let finalResult = filteredParent.filter(item => item.type !== 'separator');
			if (this.keywordSearchParent) {
				finalResult = finalResult.filter(item => item.name.toUpperCase().includes(this.keywordSearchParent.toUpperCase()));
				return finalResult;
			}
			if (this.keywordSearchOnComplete) {
				finalResult = finalResult.filter(item => item.name.toUpperCase().includes(this.keywordSearchOnComplete.toUpperCase()));
				return finalResult;
			}
			return finalResult;
		},
		userId() {
			const userId = this.user && this.user.id ? this.user.id : null;
			return userId;
		},
		params() {
			const label = this.label.trim();
			// const parentItemId = this.parentItem && this.parentItem.id ? this.parentItem.id : null;
			const parentItemId = this.selectedParent && this.selectedParent.id ? this.selectedParent.id : null;
			const onCompleteItemId = this.selectedOnComplete && this.selectedOnComplete.id ? this.selectedOnComplete.id : null;

			const content = {
				composition: this.composition,
				duration: this.duration,
				showEditor: this.showEditor,
				width: this.width,
				height: this.height,
				position: this.position,
				x: this.x,
				y: this.y,
				isRatio: this.isRatio,
				isPosition: this.isPosition,
				isParent: this.isParent,
				parentItem: parentItemId,
				onCompleteItem: onCompleteItemId,
				childOrder: this.childOrder,
				opacity: this.opacity / 100,
			};
			const contentString = JSON.stringify(content);
			const params = {
				name: label || 'Default Composition',
				type: 'composition',
				content: contentString,
				layer_index: this.layerIndex,
				rundown_id: this.rundownId,
				// status: 1,
				// is_play_live: 0,
				// is_play_preview: 0,
				// is_shy: 0,
			};
			if (!this.data.active_edit) {
				params.active_edit = this.userId;
			}
			return params;
		},
		rundownId() {
			return this.rundown ? this.rundown.id : 0;
		},
		isIndexDuplicated() {
			if (this.data) {
				// eslint-disable-next-line
				const filter = (({ id, layer_index }) => id !== this.data.id && layer_index === this.layerIndex);
				const duplicateItems = this.items.filter(filter);
				return duplicateItems.length > 0;
			}
			return false;
		},
		isLocked() {
			const index = this.items.findIndex(({ id }) => id === this.data.id);
			return this.items[index];
		},
		labelComposition() {
			let content = this.data.content;
			if (typeof content === 'string') {
				content = JSON.parse(content);
			}
			if (content && content.composition) {
				let composition = content.composition;
				if (typeof composition === 'string') {
					composition = JSON.parse(composition);
				}
				if (composition) {
					const index = this.compositions.findIndex(({ id }) => id === composition.id);
					if (index !== -1) return this.compositions[index].name;
				}
			}
			return '';
		},
		isUserEditing() {
			const index = this.items.findIndex(({ id }) => id === this.data.id);
			return this.items[index] ? this.items[index].active_edit : null;
		},
	},
	watch: {
		compositionId() {
			this.onSelect();
		},
		data() {
			if (this.data) {
				const activeEdit = this.data.active_edit;
				if (activeEdit && activeEdit !== this.userId) {
					this.isActiveEdit = true;
				} else {
					this.isActiveEdit = false;
				}
				if (this.data && activeEdit) {
					this.layerIndex = this.data.layer_index;
					this.label = this.data.name;
					let content = this.data.content;
					if (typeof content === 'string') {
						content = JSON.parse(content);
					}
					if (content) {
						this.duration = content.duration;
						this.showEditor = content.showEditor;
						this.width = content.width;
						this.height = content.height;
						this.position = content.position;
						this.x = content.x;
						this.y = content.y;
						this.isRatio = content.isRatio;
						this.isPosition = content.isPosition;
						this.isParent = content.isParent || false;
						// this.parentItem = this.filteredItems.find(item => item.id === content.parentItem) || '';
						this.selectedParent = this.filteredItems.find(item => item.id === content.parentItem) || '';
						this.selectedOnComplete = this.filteredParent.find(item => item.id === content.onCompleteItem) || '';
						this.opacity = content.opacity * 100;

						this.childOrder = content.childOrder;
						if (content.composition) {
							const compositionId = content.composition.id;
							this.composition = content.composition;
							this.compositionId = compositionId;
						}
					}
				}
			}
		},
	},
	beforeDestroy() {
		if (this.data.active_edit === this.userId) {
			this.updateActiveEdit();
		}
	},
	created() {
		this.$nextTick(() => {
			this.initData();
			this.fetchCompositions();
		});
		const userId = this.user && this.user.id ? this.user.id : '';

		const roomId = `composition_${userId}`;
		this.$socket.client.emit('join', roomId);

		this.isLoading = true;
		this.isRequired = false;
		setTimeout(() => {
			this.isRequired = true;
			this.isLoading = false;
		}, 300);
	},
	destroyed() {
		this.reset();
	},
};
</script>
